import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_APP_ENV || "local";

let initialized = false;

export function initSentry() {
	if (initialized || !dsn) return;

	Sentry.init({
		dsn,
		environment,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracesSampleRate: environment === "production" ? 0.1 : 1.0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
	});

	initialized = true;
}

export { Sentry };
